var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-point-rule',{attrs:{"has-role":_vm.hasRole}}),_c('bonus-point-rule',{attrs:{"has-role":_vm.hasRole}}),_c('level-bonus-list',{attrs:{"has-role":_vm.hasRole}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }